import { Component, OnInit, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { FieldConfig } from '@career/pocket-forms/models/field';

@Component({
  selector: 'app-cielo-login',
  templateUrl: './cielo-login.component.html',
  styleUrls: ['./cielo-login.component.scss']
})
export class CieloLoginComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
